var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 100,
    viewBox: "0 0 343 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.842 100.006H12.6862C5.71198 100.006 0 94.429 0 87.6198V13.3031C0 6.49383 5.71198 0.916986 12.6862 0.916986H329.842C336.817 0.916986 342.529 6.49383 342.529 13.3031V87.6198C342.529 94.429 336.817 100.006 329.842 100.006Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M329.842 2.90185C335.716 2.90185 340.496 7.56833 340.496 13.3031V87.6198C340.496 93.3545 335.716 98.021 329.842 98.021H12.6862C6.81251 98.021 2.03297 93.3545 2.03297 87.6198V13.3031C2.03297 7.56833 6.81251 2.90185 12.6862 2.90185H329.842ZM329.842 0.916986H12.6862C5.71198 0.916986 0 6.49383 0 13.3031V87.6198C0 94.429 5.71198 100.006 12.6862 100.006H329.842C336.817 100.006 342.529 94.429 342.529 87.6198V13.3031C342.529 6.49383 336.817 0.916986 329.842 0.916986Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.31 26.2928C120.31 28.3612 119.676 30.0179 118.426 31.2534C116.99 32.7181 115.118 33.455 112.825 33.455C110.634 33.455 108.763 32.7057 107.228 31.2286C105.689 29.7299 104.922 27.8906 104.922 25.6889C104.922 23.4873 105.689 21.648 107.228 20.1616C108.763 18.6722 110.634 17.9229 112.825 17.9229C113.916 17.9229 114.957 18.1427 115.949 18.5514C116.939 18.9633 117.744 19.5207 118.328 20.2081L117.002 21.5148C115.984 20.3412 114.598 19.7622 112.825 19.7622C111.227 19.7622 109.841 20.3072 108.664 21.4064C107.5 22.5088 106.917 23.9363 106.917 25.6889C106.917 27.4416 107.5 28.8815 108.664 29.9838C109.841 31.0707 111.227 31.6281 112.825 31.6281C114.522 31.6281 115.949 31.0707 117.075 29.9714C117.817 29.2438 118.239 28.2405 118.35 26.9585H112.825V25.1687H120.196C120.285 25.5558 120.31 25.9305 120.31 26.2928Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.003 20.0875H125.08V24.7942H131.322V26.584H125.08V31.2908H132.003V33.1146H123.12V18.2637H132.003V20.0875Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.256 33.1146H138.296V20.0875H134.049V18.2637H144.505V20.0875H140.256V33.1146Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.073 33.1146V18.2637H154.03V33.1146H152.073Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.704 33.1146H160.76V20.0875H156.498V18.2637H166.967V20.0875H162.704V33.1146Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M186.764 31.2039C185.264 32.7057 183.405 33.455 181.188 33.455C178.959 33.455 177.1 32.7057 175.6 31.2039C174.103 29.7051 173.358 27.8658 173.358 25.6889C173.358 23.5121 174.103 21.6727 175.6 20.174C177.1 18.6722 178.959 17.9229 181.188 17.9229C183.392 17.9229 185.251 18.6722 186.751 20.1864C188.261 21.6975 189.006 23.5245 189.006 25.6889C189.006 27.8658 188.261 29.7051 186.764 31.2039ZM177.049 29.9591C178.178 31.0707 179.552 31.6281 181.188 31.6281C182.812 31.6281 184.198 31.0707 185.314 29.9591C186.44 28.8474 187.011 27.4199 187.011 25.6889C187.011 23.958 186.44 22.5305 185.314 21.4188C184.198 20.3072 182.812 19.7498 181.188 19.7498C179.552 19.7498 178.178 20.3072 177.049 21.4188C175.923 22.5305 175.353 23.958 175.353 25.6889C175.353 27.4199 175.923 28.8474 177.049 29.9591Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M191.755 33.1146V18.2637H194.134L201.53 29.8137H201.616L201.53 26.9587V18.2637H203.487V33.1146H201.444L193.7 20.9948H193.614L193.7 23.8622V33.1146H191.755Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.875 54.8027C166.916 54.8027 162.048 59.2308 162.048 65.3402C162.048 71.4001 166.916 75.8746 172.875 75.8746C178.847 75.8746 183.716 71.4001 183.716 65.3402C183.716 59.2308 178.847 54.8027 172.875 54.8027ZM172.875 71.7252C169.606 71.7252 166.792 69.0901 166.792 65.3402C166.792 61.5408 169.606 58.9521 172.875 58.9521C176.145 58.9521 178.971 61.5408 178.971 65.3402C178.971 69.0901 176.145 71.7252 172.875 71.7252ZM149.25 54.8027C143.278 54.8027 138.423 59.2308 138.423 65.3402C138.423 71.4001 143.278 75.8746 149.25 75.8746C155.219 75.8746 160.078 71.4001 160.078 65.3402C160.078 59.2308 155.219 54.8027 149.25 54.8027ZM149.25 71.7252C145.977 71.7252 143.155 69.0901 143.155 65.3402C143.155 61.5408 145.977 58.9521 149.25 58.9521C152.52 58.9521 155.333 61.5408 155.333 65.3402C155.333 69.0901 152.52 71.7252 149.25 71.7252ZM121.138 58.0324V62.51H132.089C131.769 65.012 130.912 66.8513 129.599 68.1333C128.001 69.6815 125.511 71.4001 121.138 71.4001C114.398 71.4001 109.121 66.0896 109.121 59.5094C109.121 52.9293 114.398 47.6188 121.138 47.6188C124.782 47.6188 127.433 49.0091 129.39 50.8113L132.622 47.6559C129.885 45.1044 126.244 43.1443 121.138 43.1443C111.896 43.1443 104.129 50.4862 104.129 59.5094C104.129 68.5327 111.896 75.8746 121.138 75.8746C126.133 75.8746 129.885 74.2768 132.834 71.2793C135.857 68.3283 136.799 64.179 136.799 60.8286C136.799 59.7881 136.71 58.8313 136.552 58.0324H121.138ZM236.094 61.5036C235.203 59.1471 232.453 54.8027 226.852 54.8027C221.302 54.8027 216.681 59.0728 216.681 65.3402C216.681 71.2422 221.254 75.8746 227.385 75.8746C232.342 75.8746 235.203 72.9236 236.38 71.205L232.701 68.8114C231.473 70.564 229.802 71.7252 227.385 71.7252C224.984 71.7252 223.262 70.6507 222.158 68.5327L236.592 62.702L236.094 61.5036ZM221.378 65.012C221.254 60.9493 224.61 58.8685 227.014 58.8685C228.898 58.8685 230.496 59.7881 231.029 61.1042L221.378 65.012ZM209.646 75.2336H214.391V44.2683H209.646V75.2336ZM201.876 57.1499H201.718C200.652 55.9175 198.619 54.8027 196.044 54.8027C190.639 54.8027 185.698 59.4351 185.698 65.3743C185.698 71.2793 190.639 75.8746 196.044 75.8746C198.619 75.8746 200.652 74.7505 201.718 73.481H201.876V74.9921C201.876 79.0207 199.672 81.1851 196.117 81.1851C193.218 81.1851 191.419 79.1414 190.677 77.4228L186.551 79.1043C187.74 81.8973 190.89 85.3345 196.117 85.3345C201.679 85.3345 206.373 82.1389 206.373 74.3635V55.4437H201.876V57.1499ZM196.45 71.7252C193.18 71.7252 190.443 69.0529 190.443 65.3743C190.443 61.6615 193.18 58.9521 196.45 58.9521C199.672 58.9521 202.212 61.6615 202.212 65.3743C202.212 69.0529 199.672 71.7252 196.45 71.7252ZM258.308 44.2683H246.96V75.2336H251.692V63.5009H258.308C263.563 63.5009 268.717 59.7881 268.717 53.883C268.717 47.9811 263.55 44.2683 258.308 44.2683ZM258.431 59.1936H251.692V48.5756H258.431C261.964 48.5756 263.982 51.4399 263.982 53.883C263.982 56.2798 261.964 59.1936 258.431 59.1936ZM287.683 54.7439C284.264 54.7439 280.708 56.2178 279.246 59.4847L283.445 61.2032C284.349 59.4847 286.011 58.9273 287.768 58.9273C290.223 58.9273 292.713 60.3672 292.751 62.9094V63.2346C291.894 62.7515 290.061 62.0362 287.806 62.0362C283.284 62.0362 278.675 64.467 278.675 69.0034C278.675 73.1527 282.38 75.825 286.544 75.825C289.728 75.825 291.485 74.4223 292.589 72.7904H292.751V75.1841H297.321V63.3058C297.321 57.8156 293.122 54.7439 287.683 54.7439ZM287.112 71.7129C285.564 71.7129 283.407 70.9635 283.407 69.0901C283.407 66.6934 286.097 65.7737 288.425 65.7737C290.509 65.7737 291.485 66.2227 292.751 66.8141C292.38 69.6815 289.852 71.7129 287.112 71.7129ZM313.972 55.422L308.532 68.8455H308.371L302.748 55.422H297.645L306.094 74.1808L301.273 84.6192H306.217L319.236 55.422H313.972ZM271.317 75.2336H276.062V44.2683H271.317V75.2336Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.476 19.5921C25.7306 20.3538 25.2993 21.5398 25.2993 23.0757V77.8594C25.2993 79.3953 25.7306 80.5813 26.476 81.343L26.6599 81.5103L58.1027 50.8237V50.0991L26.6599 19.4125L26.476 19.5921Z",
    fill: "url(#paint0_linear_510_597)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5723 61.0576L58.103 50.8236V50.099L68.585 39.865L68.8197 39.9981L81.2332 46.8941C84.7758 48.8511 84.7758 52.0715 81.2332 54.0409L68.8197 60.9245L68.5723 61.0576Z",
    fill: "url(#paint1_linear_510_597)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8193 60.9244L58.1026 50.4613L26.4758 81.3429C27.6525 82.5506 29.5713 82.6961 31.7533 81.4885L68.8193 60.9244Z",
    fill: "url(#paint2_linear_510_597)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8193 39.9983L31.7533 19.4342C29.5713 18.239 27.6525 18.3845 26.4758 19.5921L58.1026 50.4614L68.8193 39.9983Z",
    fill: "url(#paint3_linear_510_597)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_510_597",
    x1: 55.311,
    y1: 78.43,
    x2: 13.7492,
    y2: 35.8611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_510_597",
    x1: 85.8463,
    y1: 50.4578,
    x2: 24.4528,
    y2: 50.4578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_510_597",
    x1: 62.9919,
    y1: 44.7733,
    x2: 6.6307,
    y2: -12.9536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_510_597",
    x1: 18.5147,
    y1: 99.5694,
    x2: 43.6825,
    y2: 73.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.716cad9946710378069e1dae1dd70cb8.svg";
export { ForwardRef as ReactComponent };